import { HeroHeader } from "@/components/HeroHeader";
import { DownloadSection } from "@/components/DownloadSection";
import { LandingFeatures } from "@/components/LandingFeatures";

export function App() {
  return (
    <div className="min-h-screen bg-neutral-50 dark:bg-neutral-900 text-neutral-900 dark:text-neutral-50 flex flex-col font-sans">
      <HeroHeader />
      <DownloadSection />
      <LandingFeatures />
      <footer className="py-8 text-center text-sm text-neutral-400 border-t border-neutral-100 dark:border-neutral-800">
        <p>© {new Date().getFullYear()} Proxdav. Built with Tauri & Rust.</p>
      </footer>
    </div>
  );
}

export default App;
